// import * as constants from '../constants';

// const nms = [ constants.NAMESPACE, 'store', 'state' ].join('/');
// const log = require('debug')('@mycure/vue-plugins/' + nms);

/**
 * TODO: complete the schema based on what properties are used
 * @typedef {Object} ActionCode
 * @property {string} id
 * @property {number} createdAt
 * @property {string} createdBy
 * @property {string} organization
 */

const state = {
  /** @type {ActionCode[]} */
  codes: []
};

export default state;
